export const CHECK_FREQ = [
	{
		value: "E5SEC",
		text: "Every 5 Seconds",
		label: "Every 5 Seconds",
	},
	{
		value: "E10SEC",
		text: "Every 10 Seconds",
		label: "Every 10 Seconds",
	},
	{
		value: "E15SEC",
		text: "Every 15 Seconds",
		label: "Every 15 Seconds",
	},
	{
		value: "E30SEC",
		text: "Every 30 Seconds",
		label: "Every 30 Seconds",
	},
	{
		value: "E60SEC",
		text: "Every 60 Seconds",
		label: "Every 60 Seconds",
	},
	{
		value: "E5MIN",
		text: "Every 5 Minutes",
		label: "Every 5 Minutes",
	},
	{
		value: "E10MIN",
		text: "Every 10 Minutes",
		label: "Every 10 Minutes",
	},
	{
		value: "E15MIN",
		text: "Every 15 Minutes",
		label: "Every 15 Minutes",
	},
	{
		value: "E30MIN",
		text: "Every 30 Minutes",
		label: "Every 30 Minutes",
	},
	{
		value: "E1HOUR",
		text: "Every 1 Hour",
		label: "Every 1 Hour",
	},
];

export const TYPE_LIST = [
	{
		value: "StackDriverLogBasedSmartAlert",
		text: "StackDriverLogBasedSmartAlert",
		label: "StackDriverLogBasedSmartAlert",
	},
	{
		value: "SQLBasesSmartAlert",
		text: "SQLBasesSmartAlert",
		label: "SQLBasesSmartAlert",
	},
];

export const LOG_NAME_LIST = [
	{
		value: "STDOUT",
		text: "STDOUT",
		label: "STDOUT",
	},
	{
		value: "LOAD_BALANCER",
		text: "LOAD_BALANCER",
		label: "LOAD_BALANCER",
	},
	{
		value: "K8S_AUTO_SCALER",
		text: "K8S_AUTO_SCALER",
		label: "K8S_AUTO_SCALER",
	},
	{
		value: "SLOW_SQL_QUERY",
		text: "SLOW_SQL_QUERY",
		label: "SLOW_SQL_QUERY",
	},
];

export const RECORD_LAST_MSG = [
	{
		value: "True",
		text: "Yes",
		label: "Yes",
	},
	{
		value: "False",
		text: "No",
		label: "No",
	},
];

export const LOG_LEVEL = [
	{
		value: "*",
		text: "ALL",
		label: "ALL",
	},
	{
		value: "DEBUG",
		text: "DEBUG",
		label: "DEBUG",
	},
	{
		value: "INFO",
		text: "INFO",
		label: "INFO",
	},
	{
		value: "WARN",
		text: "WARN",
		label: "WARN",
	},
	{
		value: "ERROR",
		text: "ERROR",
		label: "ERROR",
	},
];

export const GROUP_BY_LIST = [
	{
		value: "MINUTE",
		text: "Minute",
		label: "Minute",
	},
	{
		value: "FIVE_MINUTES",
		text: "Five Minutes",
		label: "Five Minutes",
	},
	{
		value: "TEN_MINUTES",
		text: "Ten Minutes",
		label: "Ten Minutes",
	},
	{
		value: "FIFTEEN_MINUTES",
		text: "Fifteen Minutes",
		label: "Fifteen Minutes",
	},
	{
		value: "THIRTY_MINUTES",
		text: "Thirty Minutes",
		label: "Thirty Minutes",
	},
	{
		value: "HOUR",
		text: "One Hour",
		label: "One Hour",
	},
];

export const DEFAULT_FORM_VALUE = {
	title: "",
	description: "",
	chilliGroup: "",
	type: "",
};

export const THRESHOLD_CHECK = [
	{
		value: "GREATER_THAN",
		text: "Greater Than",
		label: "Greater Than",
	},
	{
		value: "LESS_THAN",
		text: "Less Than",
		label: "Less Than",
	},
];
